/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PolicyExposureResponseViewModel } from './PolicyExposureResponseViewModel';
import {
    PolicyExposureResponseViewModelFromJSON,
    PolicyExposureResponseViewModelFromJSONTyped,
    PolicyExposureResponseViewModelToJSON,
} from './PolicyExposureResponseViewModel';
import type { PortfolioExposureResponseViewModel } from './PortfolioExposureResponseViewModel';
import {
    PortfolioExposureResponseViewModelFromJSON,
    PortfolioExposureResponseViewModelFromJSONTyped,
    PortfolioExposureResponseViewModelToJSON,
} from './PortfolioExposureResponseViewModel';
import type { Regulation28ResponseViewModel } from './Regulation28ResponseViewModel';
import {
    Regulation28ResponseViewModelFromJSON,
    Regulation28ResponseViewModelFromJSONTyped,
    Regulation28ResponseViewModelToJSON,
} from './Regulation28ResponseViewModel';

/**
 * 
 * @export
 * @interface ExposureResponseViewModel
 */
export interface ExposureResponseViewModel {
    /**
     * 
     * @type {PortfolioExposureResponseViewModel}
     * @memberof ExposureResponseViewModel
     */
    portfolioExposure?: PortfolioExposureResponseViewModel;
    /**
     * 
     * @type {PolicyExposureResponseViewModel}
     * @memberof ExposureResponseViewModel
     */
    policyExposure?: PolicyExposureResponseViewModel;
    /**
     * 
     * @type {Array<Regulation28ResponseViewModel>}
     * @memberof ExposureResponseViewModel
     */
    regulation28Exposure?: Array<Regulation28ResponseViewModel>;
}

/**
 * Check if a given object implements the ExposureResponseViewModel interface.
 */
export function instanceOfExposureResponseViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExposureResponseViewModelFromJSON(json: any): ExposureResponseViewModel {
    return ExposureResponseViewModelFromJSONTyped(json, false);
}

export function ExposureResponseViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExposureResponseViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'portfolioExposure': !exists(json, 'PortfolioExposure') ? undefined : PortfolioExposureResponseViewModelFromJSON(json['PortfolioExposure']),
        'policyExposure': !exists(json, 'PolicyExposure') ? undefined : PolicyExposureResponseViewModelFromJSON(json['PolicyExposure']),
        'regulation28Exposure': !exists(json, 'Regulation28Exposure') ? undefined : ((json['Regulation28Exposure'] as Array<any>).map(Regulation28ResponseViewModelFromJSON)),
    };
}

export function ExposureResponseViewModelToJSON(value?: ExposureResponseViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PortfolioExposure': PortfolioExposureResponseViewModelToJSON(value.portfolioExposure),
        'PolicyExposure': PolicyExposureResponseViewModelToJSON(value.policyExposure),
        'Regulation28Exposure': value.regulation28Exposure === undefined ? undefined : ((value.regulation28Exposure as Array<any>).map(Regulation28ResponseViewModelToJSON)),
    };
}

